<ng-container *ngIf="isTdb; else notOnTable">
  <jhi-bary-button icon="upload" [label]="(downloadURL ? 'BTN.UPDATE' : 'BTN.UPLOAD') | translate" (click)="modal.show()"></jhi-bary-button>
</ng-container>

<div mdbModal #modal="mdbModal" class="modal fade" role="dialog" aria-hidden="true">
  <div class="modal-dialog modal-lg" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h4 class="modal-title w-100 font-weight-bold" [jhiTranslate]="downloadURL ? 'UPLOAD_FILE.TITLE.UPDATE_DATA' : 'UPLOAD_FILE.TITLE.IMPORT_FILE'">Upload file</h4>
        <i aria-label="Close" (click)="modal.hide()" class="close pull-right align-middle fas fa-times"></i>
      </div>
      <div class="modal-body d-flex flex-column px-4">
        <div class="upload-zone">
          <input #uploadFile [id]="id" type="file" name="uploadedFile" ng2FileSelect [uploader]="uploader" [formControl]="control" (onFileSelected)="checkFile($event)" />
        </div>
        <div *ngIf="errors.length > 0" class="alert alert-danger mt-3" role="alert">
          {{ errors[0] }}
        </div>
        <div *ngIf="inProcessing" class="alert alert-warning mt-3" role="alert">
          <span jhiTranslate="UPLOAD_FILE.HELP_INFO.ANOTHER_FILE_ALREADY_BEING_PROCESSED">Another processing in progress</span>
          <br />
          <a href="javascript:void(0)" (click)="refreshEvent.emit()">
            <jhi-bary-icon icon="sync-alt" [faDirective]="FaDirectiveEnum.FAS" size="sm"></jhi-bary-icon>
            {{ 'BTN.REFRESH' | translate }}
          </a>
        </div>
        <div class="row justify-content-end">
          <div class="col-3">
            <jhi-bary-input-select
              [label]="'UPLOAD_FILE.DOWNLOAD_FORMAT.LABEL' | translate"
              [control]="downloadFormatControl"
              [options]="LIST_DOWNLOAD_FORMAT"
            ></jhi-bary-input-select>
          </div>
        </div>
        <div *ngIf="downloadEmptyURL" class="mt-3 p-2 border border-dark rounded bg-grey">
          <div class="d-flex justify-content-between align-items-center">
            <div>
              <jhi-bary-icon icon="file" [faDirective]="FaDirectiveEnum.FAR"></jhi-bary-icon>
              <span class="font-weight-bold">{{ 'UPLOAD_FILE.LABEL.EXAMPLE_FILE' | translate }}</span>
            </div>
            <div>
              <jhi-bary-icon icon="download" [faDirective]="FaDirectiveEnum.FAS" role="button" (click)="download(downloadEmptyURL)"></jhi-bary-icon>
            </div>
          </div>
          <div>
            <p class="mt-1 w-75 text-dark" jhiTranslate="UPLOAD_FILE.DESCRIPTION.EXAMPLE_FILE"></p>
          </div>
        </div>
        <div *ngIf="downloadURL" class="mt-3 p-2 border border-dark rounded bg-grey">
          <div class="d-flex justify-content-between align-items-center">
            <div>
              <jhi-bary-icon icon="file" [faDirective]="FaDirectiveEnum.FAR"></jhi-bary-icon>
              <span class="font-weight-bold">{{ 'UPLOAD_FILE.LABEL.YOUR_FILE' | translate }}</span>
            </div>
            <div>
              <jhi-bary-icon icon="download" [faDirective]="FaDirectiveEnum.FAS" role="button" (click)="download(downloadURL)"></jhi-bary-icon>
              <jhi-bary-icon icon="xmark" [faDirective]="FaDirectiveEnum.FAS" role="button" class="ml-1" (click)="deleteEvent.emit()"></jhi-bary-icon>
            </div>
          </div>
          <div>
            <p class="mt-1 w-75 text-dark" jhiTranslate="UPLOAD_FILE.DESCRIPTION.YOUR_FILE"></p>
          </div>
        </div>
      </div>
      <div class="modal-footer" [ngClass]="hasHelp ? 'justify-content-between' : 'justify-content-end'">
        <div *ngIf="hasHelp" role="button" (click)="helpEvent.emit()">
          <jhi-bary-icon icon="circle-question" [faDirective]="FaDirectiveEnum.FAR"></jhi-bary-icon>
          <span jhiTranslate="BTN.HELP_UPLOAD"></span>
        </div>
        <div>
          <jhi-bary-button class="mr-2" [label]="'BTN.CANCEL' | translate" [outline]="true" (click)="modal.hide()"></jhi-bary-button>
          <jhi-bary-button
            [label]="'BTN.CONFIRM' | translate"
            [disabled]="inProcessing && (uploader.queue.length === 0 || errors.length > 0)"
            (click)="uploader.uploadAll(); modal.hide()"
          ></jhi-bary-button>
        </div>
      </div>
    </div>
  </div>
</div>

<ng-template #notOnTable>
  <input #uploadFile class="d-none" type="file" name="uploadedFile" ng2FileSelect [uploader]="uploader" [formControl]="control" (onFileSelected)="checkAndUpload($event)" />
  <jhi-bary-button class="mr-2" (click)="uploadFile.click()" icon="upload" [label]="'BTN.UPLOAD' | translate"></jhi-bary-button>
</ng-template>
